/**
 * @file Homepage Menu
 */

import { gsap } from 'gsap';
import ScrollToPlugin from 'gsap/ScrollToPlugin';

/**
 * Homepage Menu component
 */
const vHpMenu = () => {
	const menu = document.querySelector( '.v-hp-menu' );

	if ( ! menu ) {
		return;
	}

	const menuTriggers = document.querySelectorAll( '[aria-controls="v-hp-menu"]' );

	if ( ! menuTriggers ) {
		return;
	}

	gsap.registerPlugin( ScrollToPlugin );

	const closeBtn   = menu.querySelector( '.v-hp-menu__close-btn' );
	const inner      = menu.querySelector( '.v-hp-menu__inner' );
	const list       = menu.querySelector( '.v-hp-menu__list' );
	const listItems  = menu.querySelectorAll( '.v-hp-menu__list-item' );
	const innerLinks = menu.querySelectorAll( '[data-internal-link]' );
	let prevFocus    = false;

	/**
	 * Handles closing the menu & animation
	 */
	const closeMenu = () => {
		gsap.timeline( {
			defaults:   { ease: 'sine.out', duration: .75 },
			onComplete: () => {
				[ ...menuTriggers ].forEach( ( t ) => {
					t.setAttribute( 'aria-expanded', 'false' );
				} );
				menu.classList.remove( 'v-hp-menu--visible' );
				menu.classList.add( 'v-hp-menu--hidden' );

				[ menu, inner, ...listItems ].forEach( ( el ) => {
					el.removeAttribute( 'style' );
				} );
			},
		} )
			.to( listItems, {
				opacity: 0,
				y:       '100%',
				stagger: -.07,
			} )
			.to( inner, {
				scale:    .7,
				opacity:  0,
				duration: .5,
			}, '>-75%' )
			.to( menu, {
				opacity:    0,
				onComplete: () => {
				},
			} );
	};

	[ ...menuTriggers ].forEach( ( t ) => {
		t.addEventListener( 'click', ( e ) => {
			const { target } = e;

			e.preventDefault();

			if ( ! menu.classList.contains( 'v-hp-menu--hidden' ) ) {
				return;
			}

			prevFocus = target;

			gsap.timeline( {
				defaults: { ease: 'sine.out', duration: .75 },
				onStart:  () => {
					t.setAttribute( 'aria-expanded', 'true' );
					menu.classList.remove( 'v-hp-menu--hidden' );
				},
				onComplete: () => {
					inner.focus();

					menu.classList.add( 'v-hp-menu--visible' );
					[ menu, inner, ...listItems ].forEach( ( el ) => {
						el.removeAttribute( 'style' );
					} );
				},
			} )
				.to( menu, {
					opacity: 1,
				} )
				.to( inner, {
					scale:   1,
					opacity: 1,
				}, '<10%' )
				.to( listItems, {
					opacity:  1,
					y:        '0%',
					stagger:  .07,
					duration: .5,
				}, '>-50%' );
		} );
	} );

	closeBtn.addEventListener( 'click', ( e ) => {
		e.preventDefault();
		closeMenu();
		prevFocus.focus();
	} );

	inner.addEventListener( 'click', ( e ) => {
		const { target } = e;

		if ( list.contains( target ) ) {
			return;
		}

		closeMenu();
		prevFocus.focus();
	} );

	const isMobileSticky = matchMedia( '(max-width: 1024px)' );
	let wasMobileSticky  = isMobileSticky.matches;
	let offsetY          = isMobileSticky.matches ? 55 : 100;
	window.addEventListener( 'resize', () => {
		if ( isMobileSticky.matches && ! wasMobileSticky ) {
			offsetY = 55;
		} else if ( ! isMobileSticky.matches && wasMobileSticky ) {
			offsetY = 100;
		}
		wasMobileSticky = isMobileSticky.matches;
	} );

	[ ...innerLinks ].forEach( ( l ) => {
		const target = document.querySelector( l.hash );

		l.addEventListener( 'click', ( e ) => {
			e.preventDefault();

			gsap.to( window, {
				duration: .5,
				scrollTo: {
					y: target,
					offsetY,
				},
				onComplete: () => {
					closeMenu();
					target.focus();
				},
			} );
		} );
	} );
};

export default vHpMenu;
